import { render } from "./Products.vue?vue&type=template&id=91d554f2&scoped=true&ts=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import "./Products.vue?vue&type=style&index=0&id=91d554f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d554f2"]])

export default __exports__